import { Box, Spacer, Text } from '@jfs/ui-new'
import { SvgImage } from '../../../comps/SvgImage'

export const InfoText = ({ title = '', ...props }) => {
    return (
        <Box flexDirection={'row'} align="flex-start" maxWidth={'90%'}>
            <SvgImage color={'#757575'} imageName={'InfoIcon'} />
            <Spacer size={8} direction="horizontal" />
            <Text {...props}>{title}</Text>
        </Box>
    )
}
